// Minimal shim for ClientSideValidations to support legacy code after removing Sprockets.
// If the real ClientSideValidations JS is loaded elsewhere, this shim will not overwrite it.
(function(root) {
  if (root.ClientSideValidations) return;

  root.ClientSideValidations = {
    formBuilders: {
      "SimpleForm::FormBuilder": {
        wrappers: {
          "default": {},
          "foundation": {}
        }
      }
    },
    callbacks: {
      form: {
        // Called when client-side validation fails on a form
        fail: function(_form, _eventData) {
          // no-op by default; legacy code may override or wrap this
        }
      }
    },
    validators: {
      local: {}
    }
  };
})(window);
